import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error) => {

      // Check if the error is an HTTP error response
      if (error instanceof HttpErrorResponse) {
        // Handle specific status codes
        switch (error.status) {
          case 401:
            console.error('Unauthorized request:', error);
            // Example: Redirect to login or refresh token
            // Note: Use inject() or a service to handle side effects
            // e.g., inject(Router).navigate(['/auth/login']);
            break;
          case 404:
            console.error('Resource not found:', error);
            // Example: Display a custom not-found message
            break;
          case 500:
            console.error('Internal server error:', error);
            // Example: Show a generic server error message
            break;
          default:
            console.error(`HTTP Error (Status: ${error.status}):`, error);
            // Handle other server errors generically
            break;
        }

        // Handle generic server errors with a custom payload
        if (error.error && typeof error.error === 'object') {
          // If the backend returns a structured error object, you can access it here.
          // For example: `const backendError = error.error.message;`
        }
      } else {
        // Handle non-HTTP errors (e.g., network issues)
        console.error('An unexpected error occurred:', error);
      }

      // Re-throw the error to be handled by the component or service.
      // This allows specific error handling higher up the call stack.
      return throwError(() => error as HttpErrorResponse);
    })
  );
};